import angular from 'angular';
import TopVltGamesWidgetComponent from './top-vlt-games-widget-component';

export default angular.module('top-vlt-games-widget', []).component('topVltGames', new TopVltGamesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/top-vlt-games/top-vlt-games-widget-module.js